// @ts-nocheck
export class Polling {
  constructor(
    API_URL,
  ) {
    Object.assign(this, {
      API_URL,
    });
    this.worker = new Worker(new URL('apps/pims/src/app/workers/polling.worker.ts', import.meta.url));
    this.worker.onmessage = this.onmessage.bind(this);
    this.pollers = new Map();
  }

  bootstrapWorker() {
    this.postMessage({
      action: 'setupEnvironment',
      payload: {
        env_vars: {
          API_URL: this.API_URL,
          BASE_URL: window.document.baseURI,
        },
      },
    });
  }

  setupSession(token) {
    this.postMessage({
      action: 'setupSession',
      payload: {
        session: token,
      },
    });
  }

  tick() {
    this.postMessage({
      action: 'tick',
    });
  }

  setupPoller(url, offset, callback) {
    if (!this.pollers.has(url)) {
      this.pollers.set(url, {
        offset,
        callback,
      });
      this.postMessage({
        action: 'setupPoller',
        payload: {
          poller: {
            offset,
            url,
          },
        },
      });
    }
  }

  updatePollerOffset(url, newOffset) {
    if (this.pollers.has(url)) {
      const oldOffset = this.pollers.get(url).offset;
      this.pollers.get(url).offset = newOffset;
      this.postMessage({
        action: 'updatePoller',
        payload: {
          poller: {
            oldOffset,
            newOffset,
            url,
          },
        },
      });
    }
  }

  destroyPoller(url) {
    if (this.pollers.has(url)) {
      const offset = this.pollers.get(url).offset;
      this.pollers.delete(url);
      this.postMessage({
        action: 'destroyPoller',
        payload: {
          poller: {
            offset,
            url,
          },
        },
      });
    }
  }

  onmessage(event) {
    switch (event.data.name) {
      case 'poll_update':
        this.pollers.get(event.data.payload[0].url)
          .callback.call(this, event.data.payload[0].update, event.data.url);
        break;
      case 'setup_poller':
        console.log('POLLING: [', event.data.payload[0].poller.url, "]");
        break;
      case 'update_poller':
        console.log('UPDATE POLL: [', event.data.payload[0].poller.url, "] ", event.data.payload[0].poller);
        break;
      case 'destroy_poller':
        console.log('DESTROY POLL: [', event.data.payload[0].poller.url, "]");
        break;
      default:
        break;
    }
  }

  postMessage(message) {
    this.worker.postMessage(message);
  }
}
Polling.$inject = ["API_URL"];
